// @ts-strict-ignore
import { Component, ContentChild, Input, TemplateRef, ViewEncapsulation } from '@angular/core';
import { uniqueId } from 'lodash-es';
import { InputBaseComponent } from '../input-base/input-base.component';
@Component({
    selector: 'ui-input-multiselect',
    templateUrl: './input-multiselect.component.html',
    styleUrls: ['./input-multiselect.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InputMultiselectComponent extends InputBaseComponent<Array<any>> {
  @Input() ariaPurpose: string;
  @Input() maxSelectedLabels: number;
  @Input() name: string = uniqueId('select');
  @Input() optionLabel: string;
  @Input() optionValue: string;
  @Input() options: any[];
  @Input() placeholder: string = '';
  @Input() selectedItemsLabel: string;
  @Input() showHeader: boolean = true;
  @ContentChild(TemplateRef) optionTemplate;

  selectedItems: any[];

  getLabel(item: any[]) {
    if (this.optionLabel) {
      return item[this.optionLabel];
    }
    return item;
  }

  onValueChange(event: PointerEvent) {
    this._emit();
  }

  // TODO: CHeck if optionValue is set and if it is compare those values
  writeValue(value: any) {
    this.selectedItems = value;
  }

  private _emit() {
    this.onChange(this.selectedItems);
    this.onTouched();
  }
}
